/* eslint-disable react-hooks/exhaustive-deps */
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
} from '@efexteam/components';
import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useApiCall } from 'use-api-call';
import DataLoadingWrapper from '../../../../components/common/DataLoadingWrapper';
import ErrorRetry from '../../../../components/common/ErrorRetry';
import { DevLabelEnum } from '../../../../configs/language/developersTranslations';
import useBoolean from '../../../../hooks/useBoolean';
import CredentialSvc from '../../../../services/credentials/CredentialSvc';
import { useAppDispatch } from '../../../../store';
import { DeleteCredentialModalProps } from '../../Credentials.interface';
import { fetchCredentials } from '../../store';

const DeleteCredentialModal = ({
  open,
  onClose,
  credential,
}: DeleteCredentialModalProps) => {
  const dispatch = useAppDispatch();
  const { t } = useTranslation();
  const [deleting, { setTrue: deleteSelected }] = useBoolean(false);
  const {
    data,
    error,
    invoke: deleteCredential,
  } = useApiCall(() => CredentialSvc.deleteCredential(credential));

  useEffect(() => {
    if (data) {
      dispatch(fetchCredentials());
      onClose();
    }
  }, [data, dispatch, onClose]);

  useEffect(() => {
    if (deleting) deleteCredential();
  }, [deleting]);

  return (
    <Dialog open={open} onClose={onClose} fullWidth maxWidth="sm">
      <DialogTitle showCloseButton onClick={onClose}>
        {t(DevLabelEnum.DEV_DELETE_TITLE)}
      </DialogTitle>
      <DialogContent>
        <div className="form-group text-center">
          {t(DevLabelEnum.DEV_DELETE_SUBTITLE, { alias: credential.alias })}
          {/* <b>{credential.alias}</b>? */}
        </div>
      </DialogContent>
      <DialogActions className="flex !justify-around" style={{ gap: '20px' }}>
        <Button
          appearance="secondary"
          size="large"
          className="mt-4"
          onClick={onClose}
        >
          {t('disagree')}
        </Button>
        {!error ? (
          <DataLoadingWrapper loadingData={deleting} variant="spinner">
            <Button
              appearance="primary"
              color="error"
              size="large"
              className="mt-4"
              onClick={deleteSelected}
            >
              {t('agree')}
            </Button>
          </DataLoadingWrapper>
        ) : (
          <ErrorRetry
            showImage={false}
            buttonClassNames="min-w-[200px]"
            onRetry={deleteSelected}
          />
        )}
      </DialogActions>
    </Dialog>
  );
};

export default DeleteCredentialModal;
